<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid" v-if="mode == 'edit'">
    <div class="row">
      <div class="col-12 custom-form-label px-0">
        {{$store.translate('procedure_name')}}
        <!--<button @click="expandName" type="button" class="btn btn-outline-light border-transparent  p-0 px-1" style="color:initial;margin-top:-3px">
          <i style="cursor:pointer" class="icon-arrow-up32 icon" v-show="nameexpanded == true"></i>
          <i style="cursor:pointer" class="icon-arrow-down32 icon" v-show="nameexpanded == false"></i>
        </button>-->
      </div>
    </div>

    <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="procedurenameForm">
      <div class="row mt-1" v-show="nameexpanded == true">
        <div class="col px-0">
          <input-text type="text" required @change="onChange($event)" id="procedurename" name="procedurename" v-bind:placeholder="$t('enter_procedure_name')" v-model="procedure.ProcedureName" style="font-size:18px;"></input-text>
        </div>
      </div>
    </form>

    <div class="row mt-3">
      <div class="col-12 custom-form-label px-0">
        {{$t('procedure_category')}}
        <!--<button @click="expand" type="button" class="btn btn-outline-light border-transparent  p-0 px-1" style="color:initial;margin-top:-3px">
          <i style="cursor:pointer" class="icon-arrow-up32 icon" v-show="categoryexpanded == true"></i>
          <i style="cursor:pointer" class="icon-arrow-down32 icon" v-show="categoryexpanded == false"></i>
        </button>-->
      </div>
    </div>
    <div class="row mt-1" v-show="categoryexpanded == true">
      <div class="col-sm-12 px-0">
        <select class="form-control" data-fouc v-bind:id="'selectprocedurecategory' + getId()" v-select='selected' v-on:change="onChangeCategory">
          <option value="-1" style="" selected>{{$t('select_category')}}</option>
          <option v-for="category in thiscategories" v-bind:value="category.CategoryId">
            {{ category.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mt-3" v-show="selected == -2 && categoryexpanded == true">
      <div class="col-12 custom-form-label px-0">
        {{$t('new_category_name')}}
      </div>
    </div>
    <div class="row mt-1" v-show="selected == -2 && categoryexpanded == true">
      <div class="col px-0">
        <input-text type="text" @change="onChange($event)" v-bind:placeholder="$t('enter_new_category_name')" v-model="procedure.NewCategoryName" style="font-size:18px;"></input-text>
      </div>
    </div>
  </div>
</template>

<script>

  var categories = [];

  export default {
    name: "procedure-name",
    components: {

    },
    props: {

      mode: {
        required: false,
        type: String,
        default: "edit"
      }
    },
    data() {
      return {
        categories,
        selected: 0,
        categoryexpanded: true,
        nameexpanded: true
      };
    },

    methods: {
      expandName() {
        this.nameexpanded = !this.nameexpanded;
        this.$forceUpdate();
      },
      expand() {
        this.categoryexpanded = !this.categoryexpanded;
        this.$forceUpdate();
      },
      onChange() {
        this.$store.markAsChanged();
      },
      getId() {
        return this._uid;
      },
      handleRefresh(val) {
        this.selected = this.procedure.CategoryId;
        var contains = this.containsCat(this.selected);

        //alert("cat:" + this.procedure.CategoryId)

        //The user might have saved the procedure with a new procedure name, in
        //this case we need to refresh the procedure list.

        if (!contains) {
          //alert('loading a new list')
          this.loadCategories();
          var thisContext = this;
          setTimeout(function () {
            $("#selectprocedurecategory" + thisContext.getId()).select2();
            $("#selectprocedurecategory" + thisContext.getId()).val(thisContext.selected);
            $("#selectprocedurecategory" + thisContext.getId()).trigger('change');
          }, 100)
        }
        else {
          //alert('selecting from existing list:' + this.selected)
          $("#selectprocedurecategory" + this.getId()).select2();
          $("#selectprocedurecategory" + this.getId()).val(this.selected);
          $("#selectprocedurecategory" + this.getId()).trigger('change');
        }
        this.$forceUpdate();

      },
      onChangeCategory(event) {
        this.selected = event.target.value;
        var procedure = this.procedure;
        procedure.CategoryId = parseInt(event.target.value);
        this.procedure = procedure;
        this.onChange(event);
      },
      containsCat(id) {
        var contains = false;
        for (var i = 0; i < this.categories.length; i++) {
          if (this.categories[i].CategoryId == id)
            contains = true;
        }
        return contains;
      },

      loadCategories() {
        try {
          var url = '/api/Procedures/v1/GetProcedureCategories';
          this.$http.get(url).then(async response => {

            var selectId = "#selectprocedurecategory" + this.getId();
            var cats = response.data;

            this.categories = [];

            if (this.containsCat(-2) == false) {
              cats.push({ Name: this.$t('add_category'), CategoryId: -2 })
              //alert("Adding category")
            }
            else {
              //alert("Already contains category")
            }

            this.categories = cats;

            Vue.set(this, "categories", cats)
            this.$forceUpdate();

            var thisContext = this;

            setTimeout(function () {
              $(selectId).select2();
              $(selectId).val(thisContext.selected);
              $(selectId).trigger('change');
            }, 100)

          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      refreshCategories(cats) {

        //cats = JSON.parse(JSON.stringify(cats));
        //cats.push({ Name: this.$t('new'), CategoryId: -2 })
        this.categories = cats

        if (this.containsCat(-2) == false) {
          cats.push({ Name: this.$t('add_category'), CategoryId: -2 });
        }

        this.categories = cats
        Vue.set(this, "categories", cats)
        this.$forceUpdate();

        var thisContext = this;
        var selectId = "#selectprocedurecategory" + this.getId();

        setTimeout(function () {
          $(selectId).select2();
          $(selectId).val(thisContext.selected);
          $(selectId).trigger('change');
        }, 100)

      }
    },
    computed: {
      thiscategories: {
        get() {
          return this.categories;
        },

      },
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 15");
          this.$store.commit('updateprocedure', value)
        }
      }
    },
    mounted() {
      _componentValidation('#procedurenameForm');
      this.loadCategories();
    },

    created: function () {

    },

    watch: {

    },
    created() {
      this.$root.$on('procedure_loaded', this.handleRefresh);
      this.$root.$on('procedure_refresh', this.handleRefresh);
      this.$root.$on('procedure_categories_refresh', this.refreshCategories);

    },
  };

</script>



// WEBPACK FOOTER //
// src/components/procedure/procedure-name.vue